import { AppState } from '../../app/state/AppState';
import { SearchResultItem, SearchResultList } from '../models/SearchResultTypes';
import { SortSelection } from '../models/SortSelection';
import { FilterQuery } from '../state/FilterState';

export function selectSingleContentTypeSearchResult(state: AppState): SearchResultList<SearchResultItem> | undefined {
  return state.singleContentType?.searchResults;
}

export function selectSearchTerm(state: AppState): string {
  return state.search.searchTerm as string;
}

export function selectFilterQuery(state: AppState): FilterQuery {
  return state.filters.query;
}

export function selectSortSelection(state: AppState): SortSelection | undefined {
  return state.search.sortBy;
}
